import React from 'react';
import { Link } from 'react-router';

// Translations
import translate from './Translate.js';

// Dependencies
import jwt_decode from 'jwt-decode';

// Components
import * as icons from './Icons/Icons';
import UserStore from '../stores/UserStore.js'

class Unauthorized extends React.Component {
  componentWillMount() {
    const token = this.props.routing.location.search.split('token=')[1];
    if(token) {
      this.payload = jwt_decode(token);
    }
  }

  render() {
    const { translation } = this.props;
    const { blockedUser } = UserStore

    console.log(this.payload);

    return(
      <main tabIndex="0" id="main-content" className="page page--error wrap">
        <div className="panel--brief">
          <i className="page--error__icon"><icons.iconLock /></i>

          {blockedUser &&
            <div>
              <h1 className='panel__title'>{translation.blocked_user.heading}</h1>
              <p>{translation.blocked_user.message}</p>
            </div>
          }

          {typeof this.payload !== 'undefined' && !blockedUser &&
            <div>
              <h1 className="panel__title">{translation.has_code.heading}</h1>
              <p>{translation.has_code.message}</p>
              <code className="text-code">{this.payload.errorMessage}</code>
            </div>
          }

          {typeof this.payload === 'undefined' && !blockedUser &&
            <div>
              <h1 className="panel__title">{translation.default.heading}</h1>
              <p>{translation.default.message}</p>
              <Link className="btn--outline" to="/">{translation.default.button}</Link>
            </div>
          }
        </div>
      </main>
    )
  }
}

export default translate('Unauthorized')(Unauthorized);


// WEBPACK FOOTER //
// ./src/app/components/Unauthorized.js